const swiperreview = new Swiper('.review-slider__contents', {
  loop: true,
  slidesPerView: 1.17,
  spaceBetween: 12, 
  pagination: {
    el: '.review-pagination',
    clickable: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
    },
    980: {
      slidesPerView: 4,
    },
  }
});